import * as React from "react";
import {ChangeableSplitter} from "../../../../util/table-splitter-ui/src/components/Splitters/ChangableSplitter";
import {FtpSyncer} from "./FtpSyncer";
import {FtpPreviewer} from "../ftpPreview/FtpPreviewer";


export interface SFTPTestPageProps {
}

export function SFTPTestPage(props: React.PropsWithChildren<SFTPTestPageProps>) {

    return <ChangeableSplitter
        name={"SFTPTestPageSplitter"}
        topOrLeft={<FtpSyncer/>}
        bottomOrRight={<FtpPreviewer/>}
    />
}